import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '=',
        sites: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'planning.Training needs' | translate}}</h1>
            <a class="btn filter" ng-click="vm.toggleFilter()">{{ 'filter.Filter courses' | translate }}</a>
        </div>
            <courses-filter-courses
                classifiers="vm.classifiers"
                list="vm.list"
                default-filter="vm.defaultFilter"
                filter="vm.filter"
                sites="vm.sites"
                component="'needs'"
                show-filter="vm.showFilter"
            />
            <planning-needs-list list="vm.list" default-filter="vm.defaultFilter" filter="vm.filter"></planning-needs-list>
    `
})
export default class {
    constructor (ListFactory, CourseResource, SiteService) {
        this.defaultFilter = { expand: 'course,courseActiveI18n,planningGroups' };
        this.filter = {};
        this.list = ListFactory.createWithPagination(CourseResource.trainingNeeds.bind(CourseResource));
        if (!SiteService.hasAccessToAllSites(this.sites)) {
            this.defaultFilter.siteId = SiteService.getActiveSiteId();
        }
        this.list.fetch(this.defaultFilter);
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/planning/needs/index.js